import React, { useContext, useState } from 'react';

import { Position } from 'types';

import { defaultImage } from 'src/constants/constants';
import { getMediumImageUrlFromImage } from 'lib/getImages';
import { flattenStrapiDataItem } from 'lib/flattenStrapiBulkDataItems';
import BuildingGalleryPopupHeaderV2 from 'componentsV2/layoutsV2/HeaderV2/GalleryPopupHeaderV2/BuildingGalleryPopupHeaderV2';
import PopUpUnitBuildingV2 from 'componentsV2/PopUpUnitBuildingV2';
import { StrapiMediaInfo } from 'apolloClient/types';
import { BuildingPageContext } from 'pages/[urlParam]/[urlBuildParam]';
import { BuildingPageContextInterface } from 'apolloClient/types/Building';
import { getBuildingFloorplans } from 'src/utils/buildingUtils';
import { TableFloorplansV2 } from './BuldingV2/FloorplansV2/TableFloorplansV2';
import FlagLabel from 'components/FlagLabel';
import PopUpContactUs from 'components/ContactUs/PopUpContactUs';
import SectionHeadingV2 from './SectionHeadingV2';

const tableFloorplansColumns = [
  {
    key: 'aptNo',
    heading: 'Apt#',
  },
  {
    key: 'bedBath',
    heading: 'Bed/Baths',
  },
  {
    key: 'floors',
    heading: 'Floors',
  },
  {
    key: 'interiorExt',
    heading: 'Interior + Ext (Sq Ft)',
    widthRatio: 2,
  },
  {
    key: 'model',
    heading: 'Model',
    widthRatio: 2,
  },
];

type BuildingFloorplansSectionV2Props = {
  images?: StrapiMediaInfo[];
  position?: Position;
  floorplans: any;
};

const BuildingFloorplansSectionV2: React.FC<BuildingFloorplansSectionV2Props> =
  ({ images, position, floorplans }) => {
    const { building } = useContext(
      BuildingPageContext
    ) as BuildingPageContextInterface;
    const floorplansData = getBuildingFloorplans(floorplans);
    const [isFloorplanDialogOpen, setFloorplanDialogOpen] = useState(false);
    const [showDirection, setShowDirection] = useState(true);
    const [activeRowIndex, setActiveRowIndex] = useState<number | undefined>(
      undefined
    );

    const imagesExists = Boolean(images && images.length > 0);

    const floorPlanExists = Boolean(floorplans && floorplans.length > 0);

    function openFloorplanDialog(rowIndex?: number) {
      setFloorplanDialogOpen(true);
      setActiveRowIndex(rowIndex);
    }

    function closeFloorplanDialog() {
      setFloorplanDialogOpen(false);
      setActiveRowIndex(undefined);
    }
    const isFloorplanRecieved = floorplans.length > 0;
    return (
      <>
        <div
          className={`flex flex-col ${
            !isFloorplanRecieved ? 's:mb-3 md:mb-0' : 'mb-0'
          }`}
        >
          <div className="relative flex flex-col justify-center mt-3 mb-10 w-max mx-5">
            <FlagLabel name={`${name} floor plans`} />
          </div>
          {isFloorplanRecieved ? <SectionHeadingV2 title="Site Plans" /> : null}
        </div>
        {isFloorplanRecieved ? (
          <div className="flex flex-col xl:flex-row xl:justify-between">
            <div className="relative xl:w-[50%]">
              <div
                className="relative w-full cursor-pointer"
                onClick={() => openFloorplanDialog()}
              >
                <img
                  className="block w-full h-auto"
                  src={
                    getMediumImageUrlFromImage(
                      flattenStrapiDataItem(building.floorPlanImage.data)
                    ) || defaultImage
                  }
                  alt={`${building.name} floorplans`}
                  onError={(event) => {
                    const img = event.currentTarget;
                    if (!img.src.endsWith(defaultImage)) img.src = defaultImage;
                  }}
                />
              </div>
            </div>
            <SectionHeadingV2 title="Floor Plans" />
            <div className="px-5 mt-5 md:mt-8 xl:mt-0 xl:ml-8 xl:w-7/12">
              <TableFloorplansV2
                columns={tableFloorplansColumns}
                data={floorplansData}
                openFloorplanDialog={openFloorplanDialog}
              />
            </div>
          </div>
        ) : (
          <div className="flex flex-col justify-center text-center">
            <div className="mb-2 font-sohneKraftig">Bummer!</div>
            <div className="mb-4 text-14-26-0.3">
              We didn’t find an exact floor plan match for this building, but we
              can likely get it for you.
            </div>
            <div className="flex i justify-center">
              <PopUpContactUs
                isRequestInfoBuilding={true}
                contactUsName={'Request floor plan'}
              />
            </div>
          </div>
        )}

        <PopUpUnitBuildingV2
          entityType="building"
          entity={building}
          open={isFloorplanDialogOpen}
          onClose={closeFloorplanDialog}
          activeTab={activeRowIndex !== undefined ? 2 : 1}
          images={images || []}
          position={position}
          tabsRenderExclude={{
            photos: !imagesExists,
            floorPlan: !floorPlanExists,
            tour: true,
            sitePlan: !floorPlanExists,
            directions: !showDirection,
          }}
          renderHeader={(onClose) => (
            <BuildingGalleryPopupHeaderV2 onClose={onClose} />
          )}
          initialActiveRowIndex={activeRowIndex}
          initialSitePlan={activeRowIndex === undefined}
        />
      </>
    );
  };

export default BuildingFloorplansSectionV2;
